import React from 'react';
import SimpleProductPage from './SimpleProductPage';
import { 
  findProductById, 
      getProductImage, 
  getProductCsvLookupId 
} from '../../utils/productHelpers';

const GarminGpsmap8612xsv = () => {
  console.log('🎯 GarminGpsmap8612xsv component loading');
  
  const product = findProductById("gpsmap-8612xsv");
  
  if (!product) {
    console.error('Product not found:', "gpsmap-8612xsv");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="gpsmap-8612xsv"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
      csvExactMatchOnly={true}
    />
  );
};

export default GarminGpsmap8612xsv; 